export enum ELinksPaths {
  katalog = '/katalog',
  wishList = '/profile/wishlist',
  compare = '/compare',
  cart = '/cart',
}
